<template>
    <div id="hello">



        <div id="content" class="homepage" >


            <h1 id="main-title"> FINANSOWANIE         </h1>

            
            <section class="section">
                <div class="container  is-fluid">
                    <div class="columns" style="flex-direction: row-reverse;">

                        <div class="column is-three-fifths padded-left">
                            <p>
                                <a href="https://mfinanse.pl/kredyt-hipoteczny-kalkulator-zdolnosci-kredytowej-podwojne-kalkulatory/" target="_blank"><img src="@/assets/img/mFinanse_logo_finanse_RGB.png?ver=1" id="mfinanse-logo" style="height: 60px; width: auto;"></a>
                            </p>
                            <p>
                                Informujemy, że nawiązaliśmy współpracę z firmą pośrednictwa kredytowego mFinanse S.A. Zapraszamy do współpracy z ekspertami, którzy przedstawią aktualne oferty kredytowe wielu banków i pomogą w finalizacji procesu kredytowego.
                            </p>
                            <h2>Kredyt hipoteczny z mFinanse to:</h2>
                            <ul>
                            <li>bezpłatna konsultacja i wsparcie eksperta&nbsp;w całym procesie kredytowym,</li>
                            <li>wyb&oacute;r najkorzystniejszej oferty&nbsp;spośr&oacute;d wielu bank&oacute;w,</li>
                            <li>zbadanie zdolności kredytowej i pomoc w analizie Twoich finans&oacute;w,</li>
                            <li>mobilność i elastyczność ekspert&oacute;w w całej Polsce, dogodne formy komunikacji.</li>
                            </ul>

                            <p style="padding-top: 1.5em;">
                                <a href="https://mfinanse.pl/formularz-biznespartner/?fn=helvetia&f=FBP-0503&e=74589" style="font-size: 1.1em; font-weight: bold;" class="button btn">Skonsultuj swój kredyt hipoteczny<br> z ekspertem mFinanse!</a>
                            </p>
                            </div>

                        <div class="column is-two-fifths">
                            <a @click="index = 0"><img src="@/assets/img/m1.jpg"></a>
                        </div>
                    </div>

                </div>
            </section>

            <hr>

            <section class="section" style="padding-top: 50px; padding-bottom: 30px;">
                <div class="container f-icons is-fluid" >
                    <h2  class="text-center" style="padding-bottom: 50px;">4 kroki do uzyskania kredytu hipotecznego z mFinanse - wspieramy Cię w całym procesie</h2>
                    <div class="columns top">

                         <div class="column text-center">
                            <div class="f-icon"><img src="@/assets/img/calendar.svg?ver=1"></div>
                            <h3><span style="font-size: 1.5em; font-weight: normal;">1.</span><br>Umów się na bezpłatną konsultację telefoniczną lub spotkanie.</h3>
                            </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/meeting1.svg?ver=1"></div>
                                <h3><span style="font-size: 1.5em; font-weight: normal;">2.</span><br>Opowiedz ekspertowi o swoich potrzebach kredytowych.</h3>
                             </div>
                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/choose-topic.svg?ver=1"></div>
                                <h3><span style="font-size: 1.5em; font-weight: normal;">3.</span><br>Wybierz ze wsparciem eksperta najlepszą ofertę spośród kilku banków.</h3>
                            </div>

                            <div class="column text-center">
                                <div class="f-icon"><img src="@/assets/img/licensing.svg?ver=1"></div>
                                <h3><span style="font-size: 1.5em; font-weight: normal;">4.</span><br>Ekspert pomoże w dopełnieniu formalności, Tobie zostaną tylko podpisy.</h3>
                            </div>

                           
                        </div>

                </div>
            </section>


            <hr>

            <section class="section odd bg-right">
                <div class="container  is-fluid">
                    <div class="columns  ">
                        <div class="column is-three-fifths">

                            <h2>Zastanawiasz się:</h2>
<ul>
<li>co wpływa na Twoją zdolność kredytową?</li>
<li>jaki wpływ na Tw&oacute;j kredyt hipoteczny mają stopy procentowe?</li>
<li>jakie oprocentowanie kredytu wybrać: stałe czy zmienne?</li>
<li>masz inne pytania odnośnie kredytu hipotecznego?</li>
</ul>
<p style="margin-top: 1.5em;">
    <a href="https://mfinanse.pl/formularz-biznespartner/?fn=helvetia&f=FBP-0503&e=74589" style="font-size: 1.1em; font-weight: bold;" class="button btn">Skonsultuj swój kredyt hipoteczny<br> z ekspertem mFinanse!</a>
</p>
                        </div>
                        <div class="column is-two-fifths">
                            <a @click="index = 0"><img src="@/assets/img/m2.jpg"   v-animate-onscroll="'animated'" class="fadeInDown"></a>
                        </div>
                    </div>
                </div>
            </section>

            <hr>





        </div>







        <CoolLightBox
                :items="photos"
                :index="index"
                @close="index = null">
        </CoolLightBox>


    </div>
</template>

<script>

    import CoolLightBox from 'vue-cool-lightbox'
    import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

    export default {
        name: 'Finances',
        data() {
            return {
                isDay: true,
                    photos: [require('@/assets/img/2_Post.jpg'),
                        require('@/assets/img/5_Post.jpg'),
                        require('@/assets/img/4_Post.jpg'),
],
                    index: null
            }
        },
        props: {
            msg: String
        },
        methods: {
            redirect(route) {
                this.$router.push(route);
            }
        },

        components: {
            CoolLightBox
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .padded-left {
        padding-left: 30px;
    }

    .btn {
        background-color: #48693a;
        display: inline-block;
        color: #fff;
        max-width: 100%;
        white-space: wrap!important;
        height: auto;

    }

    .btn br {
        display: none;
    }

    .btn:hover {
        background-color: #264c2f;
    }
    
    @media (max-width: 768px) {
        .padded-left {
            padding-left: 0;
        }

        .btn {
            display: block;
        }

        .btn br {
            display: block;
        }
        
    }
</style>
